<template>
  <div>
    <b-modal
        scrollable
      id="add-barcode-direct"
      ref="modal"
      header-class="headerModal"
      centered
      :title="`${$t('ArticleNumber')} - ${mainColorArticleName?.name}; Color - ${mainColorArticleName?.color} `"
      hide-footer
      @hide="onCancel"
    >
      <b-form-group
        :label="$t('Barcode')"
      >
        <b-form-input
          v-model="barcode"
          :placeholder="$t('Barcode')"
        />
      </b-form-group>
      <b-form-group
        :label="$t('Size')"
      >
        <vue-select
          v-model="size"
          :placeholder="$t('Size')"
          :options="getSizeTypes"
          label="name"
          :reduce="e => e.name"
          :multiple="true"
        />
      </b-form-group>
      <b-form-group
        :label="$t('PurchasePrice')"
      >
        <b-form-input
          v-model.number="purchasePrice"
          :placeholder="$t('Price')"
          type="number"
        />
      </b-form-group>
      <b-form-group
        :label="$t('SellingPrice')"
      >
        <b-form-input
          v-model.number="sellingPrice"
          :placeholder="$t('Price')"
          type="number"
        />
      </b-form-group>
      <div class="buttonsEverywhere">
        <b-button
          type="button"
          variant="none"
          class="buttonSubmit"
          style="background: #FF274F !important;"

          @click="onSubmit"
        >
          {{ $t('Submit') }}
        </b-button>
        <b-button
          type="button"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px; ; background: white; color: black; border-color: white;font-weight: 400;"

          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['mainDressColorId', 'mainDressId', 'mainColorArticleName'],
  data() {
    return {
      barcode: null,
      size: [],
      purchasePrice: 0,
      sellingPrice: 0,
    }
  },
  computed: {
    ...mapGetters(['getSizeTypes']),
  },
  mounted() {
    this.loadSizeTypes()
  },
  methods: {
    ...mapActions(['loadSizeTypes']),
    onSubmit() {
      const object = {
        code: this.barcode,
        currency: '€',
        materialVariantDtos: [],
        price: this.sellingPrice,
        purchasePrice: this.purchasePrice,
        sizes: this.size,
        mainDressCategoryColorId: this.mainDressColorId,
        mainDressCategoryId: this.mainDressId,
        articleName: this.mainColorArticleName?.name,
      }
      this.$emit('addBarcode', object)
      this.onReset()
    },
    onCancel() {
      this.onReset()
    },
    onReset() {
      this.barcode = null
      this.size = null
      this.purchasePrice = 0
      this.sellingPrice = 0
      this.$refs.modal.hide()
    },
  },
}
</script>

    <style lang="scss" scoped>

    </style>
